import { actionTypes } from "./actions";

export const initialState = {
  modelList: {},
  activeModelList: [],
  modelListNoD: []
};

// ===========================|| COMMON REDUCER ||=========================== //

const ModelReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.MODEL_GET_REQUEST:
      return {
        ...state,
        isModelLoading: true,
      };
    case actionTypes.MODEL_GET_RECEIVE:
      const abc = action.payload.filter((v,i,a)=>a.findIndex(v2=>(v2.modelName===v.modelName))===i)
      console.log("abc",abc)
      return {
        ...state,
        modelList: abc.map((dt, index) => ({ ...dt, id: index })),
        activeModelList: abc.map((dt, index) => ({label:dt.modelName, value: dt.pkModel, parent: dt.fkOem})),
        isModelLoading: false,
        modelListNoD : action.payload.map((dt, index) => ({ ...dt, id: index }))
      };
    case actionTypes.MODEL_GET_FAIL:
      return {
        ...state,
        isModelLoading: false,
        isModelFail: false,
      };
    default:
      return state;
  }
};

export default ModelReducer;
